import {Validators} from '@angular/forms';

import {DocumentReportModel} from '@spa/api';

import {
    ReportTableData,
    ReportTableColumn,
    ReportTableConfigInterface
} from '../../../app/shared/components';

import {ComponentTypesEnum} from '../../../app/shared/enums';
import {BaseControl, SelectControl} from '../../../app/shared/classes';

export const UploadedDocumentIdSelector = 'documentId';
export const UploadedDocumentTypeSelector = 'documentType';
export const UploadedDocumentSubTypeSelector = 'documentSubType';
export const UploadedDocumentStatusSelector = 'documentStatus';
export const UploadedDocumentsFormArraySelector = 'documentsFormArray';
export const UploadedDocumentsExpirationDateSelector = 'documentsExpirationDate';

export const UploadedDocumentControls = (): BaseControl<number>[] => {
    return [
        new BaseControl({
            name: UploadedDocumentIdSelector,
            value: null,
            placeholder: '',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Text
        }),
        new SelectControl({
            name: UploadedDocumentTypeSelector,
            value: null,
            placeholder: 'Type',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: UploadedDocumentSubTypeSelector,
            value: null,
            placeholder: 'Sub Type',
            validators: [],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        }),
        new SelectControl({
            name: UploadedDocumentStatusSelector,
            value: null,
            placeholder: 'Status',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: [],
            floatingLabelNever: true
        })
    ];
};

export const PanelClientsEditDocumentsDataTableItems = (): ReportTableData[] => {
    return [       
        new ReportTableData<number>({
            colId: DocumentReportModel.getDocumentTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: DocumentReportModel.getDocumentSubTypeSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getDocumentStatusSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getExpirationDateSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getUploadedStampSelector(),
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: DocumentReportModel.getDescriptionSelector(),
            value: null,
            hidden: false
        })
    ];
};

export const PanelClientsEditDocumentsDataTableConfig: ReportTableConfigInterface = {
    rows: [],
    columns: [
        new ReportTableColumn({
            label: 'Type',
            selector: DocumentReportModel.getDocumentTypeSelector()
        }),
        new ReportTableColumn({
            label: 'Sub Type',
            selector: DocumentReportModel.getDocumentSubTypeSelector()
        }),
        new ReportTableColumn({
            label: 'Status',
            selector: DocumentReportModel.getDocumentStatusSelector()
        }),
        new ReportTableColumn({
            label: 'Expiration date',
            selector: DocumentReportModel.getExpirationDateSelector()
        }),
        new ReportTableColumn({
            label: 'Created Date',
            selector: DocumentReportModel.getUploadedStampSelector()
        }),
        new ReportTableColumn({
            label: 'Description',
            selector: DocumentReportModel.getDescriptionSelector()
        })
    ],
    hiddenColumnIds: [],
    actionMenu: false,
};
